
export class Filter {
  id: number;
  type: string;

}



// WEBPACK FOOTER //
// ./src/app/shared/models/filter.model.ts